import type { FC } from 'react';
import React, { useEffect, useRef } from 'react';
import { ChevronRightIcon } from '@interstate/components/Icons/ChevronRightIcon';
import { useExpandableArea } from '../../common/ExpandableArea';
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import { StyledToggleAll } from './ChevronIcon.style';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const ChevronIcon: FC<{
    expandableId: string;
    isDetailsSection?: boolean;
}> = ({ expandableId, isDetailsSection }) => {
    const { isExpanded, isAllExpanded, doToggleAll } = useExpandableArea();
    const expanded = isDetailsSection ? isAllExpanded() : isExpanded(expandableId);
    const showBreakdown = useTrackedSelector(baseDealSelectors.getBreakdownStatus, {
        component: 'ChevronIcon',
        field: 'breakdownStatus'
    });
    const iconRef = useRef<HTMLDivElement>(null);
    const breakdownActionSource = useTrackedSelector(baseDealSelectors.getBreakdownActionSource, {
        component: 'ChevronIcon',
        field: 'breakdownActionSource'
    });

    const iconStyle = {
        transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        marginRight: '0.4rem'
    };

    useEffect(() => {
        if (showBreakdown && iconRef.current && breakdownActionSource) {
            iconRef.current.focus();
        }
    }, [showBreakdown, breakdownActionSource]);

    return isDetailsSection ? (
        <StyledToggleAll
            ref={iconRef}
            tabIndex={0}
            onClick={() => doToggleAll()}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    doToggleAll();
                }
            }}
            id="expandable-root-chevron-icon"
            data-testid="expandable-root-chevron-icon"
        >
            <ChevronRightIcon style={{ ...iconStyle, marginRight: '0rem' }} className="chevron-icon" data-testid={expandableId} />
        </StyledToggleAll>
    ) : (
        <ChevronRightIcon style={iconStyle} className="chevron-icon" data-testid={expandableId} />
    );
};

export default ChevronIcon;
